export default __webpack_public_path__ + "static/media/project4.8c61d515.png";